import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Icon from '@material-ui/core/Icon';
import Card from '../Card/Card';
import CardBody from '../Card/CardBody';
import CardHeader from '../Card/CardHeader';
import customTabsStyle from '../../assets/jss/material-kit-react/components/customTabsStyle';
class CustomTabs extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            value: 0,
        };
        this.handleChange = (event, value) => {
            this.setState({ value });
        };
    }
    render() {
        const { classes, headerColor, plainTabs, tabs, title, rtlActive, } = this.props;
        const cardTitle = classNames({
            [classes.cardTitle]: true,
            [classes.cardTitleRTL]: rtlActive,
        });
        return (React.createElement(Card, { plain: plainTabs },
            React.createElement(CardHeader, { color: headerColor, plain: plainTabs },
                title !== undefined ? (React.createElement("div", { className: cardTitle }, title)) : null,
                React.createElement(Tabs, { value: this.state.value, onChange: this.handleChange, classes: {
                        root: classes.tabsRoot,
                        indicator: classes.displayNone,
                    } }, tabs.map((prop, key) => {
                    var icon = {};
                    if (prop.tabIcon) {
                        icon = {
                            icon: typeof prop.tabIcon === 'string' ? (React.createElement(Icon, null, prop.tabIcon)) : (React.createElement(prop.tabIcon, null)),
                        };
                    }
                    return (React.createElement(Tab, Object.assign({ classes: {
                            root: classes.tabRootButton,
                            labelContainer: classes.tabLabelContainer,
                            label: classes.tabLabel,
                            selected: classes.tabSelected,
                            wrapper: classes.tabWrapper,
                        }, key: key, label: prop.tabName }, icon)));
                }))),
            React.createElement(CardBody, null, tabs.map((prop, key) => {
                if (key === this.state.value) {
                    return React.createElement("div", { key: key }, prop.tabContent);
                }
                return null;
            }))));
    }
}
CustomTabs.propTypes = {
    classes: PropTypes.object.isRequired,
    headerColor: PropTypes.oneOf([
        'warning',
        'success',
        'danger',
        'info',
        'primary',
        'rose',
    ]),
    title: PropTypes.string,
    tabs: PropTypes.arrayOf(PropTypes.shape({
        tabName: PropTypes.string.isRequired,
        tabIcon: PropTypes.func,
        tabContent: PropTypes.node.isRequired,
    })),
    rtlActive: PropTypes.bool,
    plainTabs: PropTypes.bool,
};
export default withStyles(customTabsStyle)(CustomTabs);
//# sourceMappingURL=CustomTabs.js.map